const server_url = process.env.VUE_APP_SERVER_URL
const server_api_url = process.env.VUE_APP_SERVER_API_URL

// When the SPA runs on WEB_HOME (e.g. https://host/liff/activity), use same-origin
// /api/v1/ (Nginx web tier). Otherwise fall back to VUE_APP_SERVER_API_URL (:7096).
function resolveApiV1Url() {
  const fallback = server_api_url + 'api/v1/'
  if (typeof window === 'undefined') {
    return fallback
  }
  try {
    const webOrigin = new URL(server_url).origin
    if (window.location.origin === webOrigin) {
      return webOrigin + '/api/v1/'
    }
  } catch (e) {
    // ignore invalid WEB_HOME
  }
  return fallback
}

let Constants = {
  //  install
  install(Vue, options) {
    //  create global Constants
    Vue.Constants = {
      VERSION: 0.8,

      // FRONT END
      WEB_HOME: server_url,

      // API
      BADMINTON_API_URL: server_api_url,
      BADMINTON_API_V1_URL: resolveApiV1Url(),
      BADMINTON_API_HEADER_AUTH: 'authorization',
      BADMINTON_API_HEADER_ID_TYPE: 'x-id-type',
      BADMINTON_API_URL_IMAGES: server_api_url + 'images/',

      // ID type
      ID_TYPE_NONE: 0,
      ID_TYPE_LINE: 1,

      // LINE
      LINE_CLIENT_ID: process.env.VUE_APP_LINE_CLIENT_ID,
      LINE_REDIRECT_URL: server_url + 'line/callback',
      LINE_SCOPE: 'profile openid',
      LINE_SECRET: process.env.VUE_APP_LINE_SECRET,

      // Notifications
      NOTIF_GROUP_COMMON: 'common',
      NOTIF_DURATION_DEFAULT: 5000,
      NOTIF_DURATION_INFINITE: -1,
      NOTIF_SPEED_DEFAULT: 1500,

      // Text of notification
      TEXT_NOTIFICATION_ERROR: 'Error',
      TEXT_NOTIFICATION_SUCCESS: 'Success',
      TEXT_NOTIFICATION_WARNING: 'Warning',

      // keys of local storage
      KEY_LS_LINE_STATE: 'k_ls_a',
      KEY_LS_LINE_NONCE: 'k_ls_b',
      KEY_LS_LINE_REFRESH_TOKEN: 'k_ls_c',
      KEY_LS_LINE_ACCESS_TOKEN: 'k_ls_d',
      // KEY_LS_LINE_ID_TOKEN: 'k_ls_e',

      // activity
      ACTIVITY_STATUS_DRAFT: 0,
      ACTIVITY_STATUS_OPEN: 1,
      ACTIVITY_STATUS_SURE2GO: 2,
      ACTIVITY_STATUS_CANCELED: 3,
      ACTIVITY_STATUS_FAILURE: 4,
      ACTIVITY_STATUS_FINISHED: 5,
      ACTIVITY_STATUS_KICKOFF: 6,
    }
  }
}

export default Constants
